import throttle from "lodash/throttle";
import { type RefObject, useCallback, useEffect, useState } from "react";

export function useMinHeightByRef(ref: RefObject<HTMLElement[]>) {
  const [minHeight, setMinHeight] = useState<number>();

  const updateMinHeight = useCallback(() => {
    if (ref.current.length === 0) return;

    const elements = Array.from(ref.current);
    const height = Math.max(...elements.map((el) => el.clientHeight));
    setMinHeight(height);
  }, [ref]);

  useEffect(() => {
    updateMinHeight();

    const fn = throttle(updateMinHeight, 200);
    window.addEventListener("resize", fn);

    return () => {
      window.removeEventListener("resize", fn);
    };
  }, [updateMinHeight]);

  return minHeight;
}
